import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './ProficiencyTagRanking.scss';
var questionKeyToTagType = function questionKeyToTagType(key) {
  var arr = key.replace('_ranking', '').replace(/_/g, ' ').split('');
  var firstLetter = arr.shift();
  return [firstLetter.toUpperCase()].concat(arr);
};
var sortTags = function sortTags(tags) {
  var ranked = [];
  var unranked = [];
  tags.forEach(function (tag) {
    if (tag.ranking) {
      ranked.push(tag);
    } else {
      unranked.push(tag);
    }
  });
  ranked.sort(function (tagA, tagB) {
    return tagA.ranking - tagB.ranking;
  });
  return {
    ranked: ranked,
    unranked: unranked
  };
};
var ProficiencyTagRanking = /*#__PURE__*/function (_React$Component) {
  function ProficiencyTagRanking(props) {
    var _this;
    _classCallCheck(this, ProficiencyTagRanking);
    _this = _callSuper(this, ProficiencyTagRanking, [props]);
    var sortedTags = sortTags(props.answer);
    _this.state = {
      rankedTags: sortedTags.ranked,
      unrankedTags: sortedTags.unranked
    };
    _this.tagType = questionKeyToTagType(props.questionKey);
    _this.handleTagsUpdated = _this.handleTagsUpdated.bind(_this);
    _this.handlePromote = _this.handlePromote.bind(_this);
    _this.handleDemote = _this.handleDemote.bind(_this);
    return _this;
  }
  _inherits(ProficiencyTagRanking, _React$Component);
  return _createClass(ProficiencyTagRanking, [{
    key: "handleTagsUpdated",
    value: function handleTagsUpdated() {
      var _this$props = this.props,
        handleChange = _this$props.handleChange,
        questionKey = _this$props.questionKey;
      var _this$state = this.state,
        rankedTags = _this$state.rankedTags,
        unrankedTags = _this$state.unrankedTags;
      handleChange(questionKey, rankedTags, unrankedTags);
    }
  }, {
    key: "handlePromote",
    value: function handlePromote(existingTag) {
      var _this2 = this;
      var rankedTags = this.state.rankedTags;
      var unrankedTags = this.state.unrankedTags;
      return function () {
        var tag = _objectSpread({}, existingTag);
        if (tag.ranking === 1) return;
        if (tag.ranking) {
          tag.ranking -= 1;
          var swapTag = _objectSpread({}, rankedTags.find(function (t) {
            return t.ranking === tag.ranking;
          }));
          swapTag.ranking += 1;
          _this2.setState({
            rankedTags: rankedTags.map(function (t) {
              if (t.value === tag.value) {
                return tag;
              }
              if (t.value === swapTag.value) {
                return swapTag;
              }
              return t;
            }).sort(function (a, b) {
              return a.ranking - b.ranking;
            })
          }, _this2.handleTagsUpdated);
        } else if (rankedTags.length >= 3) {
          var lowestRankedTag = rankedTags.pop();
          lowestRankedTag.ranking = null;
          tag.ranking = 3;
          _this2.setState({
            rankedTags: rankedTags.concat([tag]),
            unrankedTags: unrankedTags.filter(function (t) {
              return t.value !== tag.value;
            }).concat([lowestRankedTag])
          }, _this2.handleTagsUpdated);
        } else {
          tag.ranking = rankedTags.length + 1;
          _this2.setState({
            rankedTags: rankedTags.concat([tag]),
            unrankedTags: unrankedTags.filter(function (t) {
              return t.value !== tag.value;
            })
          }, _this2.handleTagsUpdated);
        }
      };
    }
  }, {
    key: "handleDemote",
    value: function handleDemote(existingTag) {
      var _this3 = this;
      var rankedTags = this.state.rankedTags;
      var unrankedTags = this.state.unrankedTags;
      return function () {
        var tag = _objectSpread({}, existingTag);
        if (!tag.ranking) return;
        tag.ranking = null;
        _this3.setState({
          rankedTags: rankedTags.filter(function (t) {
            return t.value !== tag.value;
          }),
          unrankedTags: [tag].concat(unrankedTags)
        }, _this3.handleTagsUpdated);
      };
    }
  }, {
    key: "renderTag",
    value: function renderTag(tag) {
      var clickAction = tag.ranking ? this.handleDemote(tag) : this.handlePromote(tag);
      return /*#__PURE__*/React.createElement(Row, {
        className: "proficiency-ranking-tag tag-label ".concat(tag.ranking ? 'ranked' : ''),
        id: "rankable-".concat(tag.value),
        onClick: clickAction,
        role: "button",
        tabIndex: 0
      }, /*#__PURE__*/React.createElement(Col, {
        xs: 1,
        className: "ranked-tag-icon"
      }, tag.ranking && /*#__PURE__*/React.createElement("i", {
        className: "fas fa-check"
      })), /*#__PURE__*/React.createElement(Col, {
        xs: 11
      }, tag.label));
    }
  }, {
    key: "renderTagsList",
    value: function renderTagsList(tags) {
      var _this4 = this;
      return /*#__PURE__*/React.createElement(Fragment, null, tags.map(function (tag) {
        return _this4.renderTag(tag);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
        rankedTags = _this$state2.rankedTags,
        unrankedTags = _this$state2.unrankedTags;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 demibold mb-12"
      }, this.tagType, ":"), /*#__PURE__*/React.createElement("div", {
        className: "proficiency-tag-ranking-container style-guide"
      }, this.renderTagsList(rankedTags), this.renderTagsList(unrankedTags)));
    }
  }]);
}(React.Component);
ProficiencyTagRanking.propTypes = {
  answer: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  questionKey: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired
};
export default ProficiencyTagRanking;